import { render, staticRenderFns } from "./approveChallenge.vue?vue&type=template&id=e4543c00&scoped=true&"
import script from "./approveChallenge.vue?vue&type=script&lang=js&"
export * from "./approveChallenge.vue?vue&type=script&lang=js&"
import style0 from "./approveChallenge.vue?vue&type=style&index=0&id=e4543c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4543c00",
  null
  
)

export default component.exports